package game.entity

import game.Game
import game.Room

class Door: Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("shard-door")
        fixed = true
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.message = game.text("Message_Door")
        return false
    }
}